import { route } from '@betterment/js-runtime';

import brochureUrl from './brochureUrl';

export const urlBuilder = {
  graphQL: route('', ['/graphql']),
  dashboard: route('', ['/dashboard']),
  support: route('', ['/support']),
  profileEmailPreferencesEdit: route('', ['profile', 'email_preferences', 'edit']),
  reports: route('', ['reports']),
  reportsNew: route('', ['reports', 'new']),
  getSignablePackageDownload(signablePackageId: string) {
    return `/signable_package_download/${signablePackageId}`;
  },
  getSignablePackageSuccess(signablePackageId: string, returnToPath?: string) {
    return `/signable_packages/${signablePackageId}/success${returnToPath ? `?returnTo=${encodeURIComponent(returnToPath)}` : ''}`;
  },
  getUnallocatedFundsGuide() {
    return brochureUrl('/work/resources/what-are-unallocated-funds');
  },
};
